import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// The session lives in an httpOnly cookie now (see api.js). Cookies
// aren't sent cross-origin by default, so this makes every fetch()
// call in the app include credentials automatically — one place
// instead of editing every fetch() call across every page.
const _fetch = window.fetch.bind(window);
// A 401 from the API means "session may be gone": tell AuthProvider to re-validate (it decides about
// the redirect). Translation endpoints are excluded so a mid-run error stays visible on the page.
const QUIET_401 = ["/api/translate", "/api/save-translated", "/api/subtitle-texts", "/api/auth/", "/api/profile"];
window.fetch = (input, init = {}) =>
  _fetch(input, { credentials: "include", ...init }).then((res) => {
    try {
      if (res.status === 401) {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        if (url.startsWith("/api/") && !QUIET_401.some((p) => url.startsWith(p)))
          window.dispatchEvent(new Event("subai:unauthorized"));
      }
    } catch { /* never let diagnostics break a request */ }
    return res;
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
